import { useQuery, UseQueryResult } from '@tanstack/react-query';

import {
  getTerritories,
  GetTerritoriesParams,
} from '@/actions/territories/getTerritories';
import { ApiResponse } from '@/types/response.type';
import { Territory } from '@/types/territories/territory.type';

export interface UseGetTerritoriesReturn {
  result: ApiResponse<Territory[]> | undefined;
  error: Error | null;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
}

export const useGetTerritories = (
  params?: GetTerritoriesParams
): UseGetTerritoriesReturn => {
  const query: UseQueryResult<ApiResponse<Territory[]> | undefined, Error> =
    useQuery({
      queryKey: ['territories', params],
      queryFn: () => getTerritories(params),
      refetchInterval: 30 * 1000, // 30 seconds
      refetchIntervalInBackground: true,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
    });

  return {
    result: query.data,
    error: query.error,
    isError: query.isError,
    isSuccess: query.isSuccess,
    isLoading: query.isPending,
  };
};
